import React, { useState, useEffect } from 'react';
import Clessidra from '../Pagine/Clessidra';
import stile from './stile.module.css';

function Docce(props) {

    const PAGINE = {
        caricamentoDati: 1,
        riepilogo: 2,
        elenco: 3
    };

    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [conteggioDocce, setConteggioDocce] = useState(0);
    const [elencoDocce, setElencoDocce] = useState([]);

    function erroreBackend() {
        window.alert(
            "Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"
        );
        props.callback(props.PAGINECLIENTI.login);
    }

    function verificaRisposta(valoreDiRitorno) {
        if (valoreDiRitorno.verifvers === 0) {
            props.callbackAggiornaApp();
            return false;
        }

        if (valoreDiRitorno.risultatoOperazione === 2) {
            props.callback(props.PAGINECLIENTI.login);
            return false;
        }

        if (valoreDiRitorno.risultatoOperazione !== 1) {
            erroreBackend();
            return false;
        }

        return true;
    }

    function scaricaConteggioDocce() {

        setPagina(PAGINE.caricamentoDati);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                op: "docceConteggio",
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valoreDiRitorno) => {

                    if (!verificaRisposta(valoreDiRitorno)) return;

                    setConteggioDocce(
                        parseInt(valoreDiRitorno.conteggioDocce, 10) || 0
                    );

                    setPagina(PAGINE.riepilogo);
                },
                () => {
                    props.callback(props.PAGINECLIENTI.login);
                }
            );
    }

    function scaricaElencoDocce() {

        setPagina(PAGINE.caricamentoDati);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                op: "docceElenco",
                emak: props.emak,
                sessionId: props.sessionId
            })
        };

        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valoreDiRitorno) => {

                    if (!verificaRisposta(valoreDiRitorno)) return;

                    setElencoDocce(
                        Array.isArray(valoreDiRitorno.elencoDocce)
                            ? valoreDiRitorno.elencoDocce
                            : []
                    );

                    setPagina(PAGINE.elenco);
                },
                () => {
                    props.callback(props.PAGINECLIENTI.login);
                }
            );
    }

    function formattaDataOra(dataora) {

        if (!dataora) return "";

        const match = String(dataora).match(
            /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/
        );

        if (!match) return dataora;

        return (
            match[3] + "/" +
            match[2] + "/" +
            match[1] + " " +
            match[4] + ":" +
            match[5]
        );
    }

    function descrizioneOperazione(record) {

        switch (record.OPERAZIONE) {

            case "D":
                return "Doccia";

            case "R":
                return "Ricarica";

            case "A":
                return "Ricarica automatica";

            case "E":
                return "Eliminazione";

            default:
                return record.OPERAZIONE;
        }
    }

    function formattaVariazione(variazione) {

        const valore = parseInt(variazione, 10);

        if (!Number.isFinite(valore)) return variazione;

        if (valore > 0) return "+" + valore;

        return String(valore);
    }

    useEffect(() => {
        scaricaConteggioDocce();
    }, []);

    // gestione del tasto BACK
    useEffect(() => {

        if (!props.flagRichiestaBack) return;

        props.setFlagRichiestaBack(false);

        if (pagina === PAGINE.elenco) {
            setPagina(PAGINE.riepilogo);
        } else {
            props.callback(props.PAGINECLIENTI.home);
        }

    }, [props.flagRichiestaBack]);

    if (pagina === PAGINE.caricamentoDati) {
        return <Clessidra loading={true} />;
    }

    if (pagina === PAGINE.riepilogo) {
        return (
            <div className={stile.contenitorePrincipale}>
                <div className={stile.doccePagina}>

                    <div className={stile.docceRiepilogo}>

                        <div className={stile.docceTitoloDisponibili}>
                            Docce disponibili
                        </div>

                        <div className={stile.docceNumeroDisponibili}>
                            {conteggioDocce}
                        </div>

                        <div className={stile.docceBottoniRiepilogo}>

                            <div
                                className={stile.docceBottoneRiepilogo}
                                onClick={() => props.callback(props.PAGINECLIENTI.home)}
                            >
                                Indietro
                            </div>

                            <div
                                className={stile.docceBottoneRiepilogo}
                                onClick={scaricaElencoDocce}
                            >
                                Visualizza Storico
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        );
    }

    if (pagina === PAGINE.elenco) {

        return (
            <div className={stile.contenitorePrincipale}>
                <div className={stile.doccePagina}>

                    {elencoDocce.length > 0 ? (

                        <div className={stile.docceElenco}>

                            {elencoDocce.map((x, i) => {

                                const variazione = parseInt(x.VARIAZIONE, 10) || 0;

                                return (
                                    <div
                                        key={x.ID || i}
                                        className={stile.docceElemento}
                                    >

                                        <div className={stile.docceDataOra}>
                                            {formattaDataOra(x.DATAORA)}
                                        </div>

                                        <div className={stile.docceOperazione}>
                                            {descrizioneOperazione(x)}
                                        </div>

                                        <div
                                            className={[
                                                stile.docceVariazione,
                                                variazione > 0
                                                    ? stile.docceVariazionePositiva
                                                    : variazione < 0
                                                        ? stile.docceVariazioneNegativa
                                                        : ""
                                            ].join(" ")}
                                        >
                                            {formattaVariazione(x.VARIAZIONE)}
                                        </div>

                                    </div>
                                );
                            })}

                        </div>

                    ) : (

                        <div className={stile.docceNessunMovimento}>
                            Non ci sono ancora movimenti docce
                        </div>

                    )}

                    <div className={stile.docceSpazioBottoneIndietro}>
                        <div
                            className={stile.docceBottoneIndietro}
                            onClick={() => setPagina(PAGINE.riepilogo)}
                        >
                            Indietro
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    return <div>Errore pagina non trovata (Docce)</div>;
}

export default Docce;